"use strict";

(function (global, factory) {
  factory(require("../froala_3.0.5/js/froala_editor"));
})(void 0, function (FE) {
  "use strict";

  FE = FE && FE.hasOwnProperty("default") ? FE["default"] : FE;
  Object.assign(FE.POPUP_TEMPLATES, {
    "cpImage.insert": "[_BUTTONS_][_PROGRESS_BAR_]",
    "cpImage.edit": "[_BUTTONS_]",
    "cpImage.alt": "[_BUTTONS_][_ALT_LAYER_]",
    "cpImage.size": "[_BUTTONS_][_SIZE_LAYER_]",
    "cpImage.link": "[_BUTTONS_][_LINK_LAYER_]"
  });
  Object.assign(FE.DEFAULTS, {
    cpImage: {
      imageInsertButtons: [],
      imageEditButtons: ["cpImageReplace", "cpImageAlign", "cpImageRemove", "|", "cpImageLink", "cpImageLinkOpen", "cpImageLinkEdit", "cpImageLinkRemove", "-", "cpImageDisplay", "cpImageStyle", "cpImageAlt", "cpImageSize"],
      imageAltButtons: ["cpImageBack", "|"],
      imageSizeButtons: ["cpImageBack", "|"],
      imageLinkButtons: ["cpImageBack", "|"],
      imageResize: true,
      imageResizeWithPercent: false,
      imageRoundPercent: false,
      imageDefaultAlign: "center",
      imageDefaultDisplay: "block",
      imageSplitHTML: false,
      imageStyles: {
        "fr-rounded": "Rounded",
        "fr-bordered": "Bordered"
      },
      imageMove: true,
      imageMultipleStyles: true,
      imageTextNear: true,
      imagePaste: false,
      imagePasteProcess: false,
      imageMinWidth: 16,
      imageOutputSize: false
    }
  });

  FE.PLUGINS.cpImage = function (editor) {
    var $current_image;
    var $image_resizer;
    var $handler;
    var $overlay;
    var mousedown = false;

    var $ = window.$ || require("jquery");

    var BAD_LINK = 1;
    var MISSING_LINK = 2;
    var BAD_RESPONSE = 4;
    var INVALID_NODE = 8;
    var error_messages = {};
    error_messages[BAD_LINK] = "Image cannot be loaded from the passed link.";
    error_messages[MISSING_LINK] = "No link in upload response.";
    error_messages[BAD_RESPONSE] = "Parsing response failed.";
    error_messages[INVALID_NODE] = "Range selection threw invalid node error.";
    /**
     * Refresh the image insert popup.
     */

    function _refreshInsertPopup() {
      var $popup = editor.popups.get("cpImage.insert");
      var $url_input = $popup.find(".fr-image-by-url-layer input");
      $url_input.val("");

      if ($current_image) {
        $url_input.val($current_image.attr("src"));
      }

      $url_input.trigger("change");
    }
    /**
     *  Called when clicking insert image link.
     */


    function insertImage() {
      editor.selection.save();
      openCpImageModal(this);
    }
    /**
     * Show the image upload popup.
     */


    function showInsertPopup() {
      var $btn = editor.$tb.find('.fr-command[data-cmd="cpImage"]');
      var $popup = editor.popups.get("cpImage.insert");
      if (!$popup) $popup = _initInsertPopup();
      hideProgressBar();

      if (!$popup.hasClass("fr-active")) {
        editor.popups.refresh("cpImage.insert");
        editor.popups.setContainer("cpImage.insert", editor.$tb);

        if (!$btn.is("hidden")) {
          var left = $btn.offset().left + $btn.outerWidth() / 2;
          var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
          editor.popups.show("cpImage.insert", left, top, $btn.outerHeight());
        } else {
          editor.position.forSelection($popup);
          editor.popups.show("cpImage.insert");
        }
      }
    }
    /**
     * Show the image edit popup.
     */


    function _showEditPopup() {
      //With slideshow implementation, need to init every time to get updated image edit popup data
      editor.popups.hide("cpImage.edit");

      var $popup = _initEditPopup();

      editor.popups.setContainer("cpImage.edit", $(editor.opts.scrollableContainer));
      editor.popups.refresh("cpImage.edit");
      var left = $current_image.offset().left + $current_image.outerWidth() / 2;
      var top = $current_image.offset().top + $current_image.outerHeight();
      editor.popups.show("cpImage.edit", left, top, $current_image.outerHeight());
      window.setTimeout(function () {
        var $img = window.isIE11() ? $(".selectedFroalaImage") : $current_image;

        if ($img.parent("a").length > 0) {
          $popup.find("#cpImageLinkOpen-" + editor.id).removeClass("fr-hidden");
          $popup.find("#cpImageLinkEdit-" + editor.id).removeClass("fr-hidden");
          $popup.find("#cpImageLinkRemove-" + editor.id).removeClass("fr-hidden");
          $popup.find("#cpImageLink-1" + editor.id).addClass("fr-hidden");
        } else {
          $popup.find("#cpImageLinkOpen-" + editor.id).addClass("fr-hidden");
          $popup.find("#cpImageLinkEdit-" + editor.id).addClass("fr-hidden");
          $popup.find("#cpImageLinkRemove-" + editor.id).addClass("fr-hidden");
          $popup.find("#cpImageLink-" + editor.id).removeClass("fr-hidden");
        }
      }, 50);
    }
    /**
     * Hide image upload popup.
     */


    function _hideInsertPopup() {
      hideProgressBar();
    }
    /**
     * Convert style to classes.
     */


    function _convertStyleToClasses($img) {
      if (!$img.hasClass("fr-dii") && !$img.hasClass("fr-dib")) {
        // Set float to none.
        var flt = $img.css("float");
        $img.css("float", "none"); // Image has display block.

        if ($img.css("display") == "block") {
          // Set float to the initial value.
          $img.css("float", flt);

          if (editor.opts.cpImage.imageEditButtons.indexOf("imageAlign") >= 0) {
            // Margin left is 0.
            // Margin right is auto.
            if (parseInt($img.css("margin-left"), 10) === 0 && ($img.attr("style") || "").indexOf("margin-right: auto") >= 0) {
              $img.addClass("fr-fil");
            } // Margin left is auto.
            // Margin right is 0.
            else if (parseInt($img.css("margin-right"), 10) === 0 && ($img.attr("style") || "").indexOf("margin-left: auto") >= 0) {
                $img.addClass("fr-fir");
              }
          }

          $img.addClass("fr-dib");
        } // Display inline.
        else {
            // Set float.
            $img.css("float", flt);

            if (editor.opts.cpImage.imageEditButtons.indexOf("imageAlign") >= 0) {
              // Float left.
              if ($img.css("float") == "left") {
                $img.addClass("fr-fil");
              } // Float right.
              else if ($img.css("float") == "right") {
                  $img.addClass("fr-fir");
                }
            }

            $img.addClass("fr-dii");
          } // Reset inline style.


        $img.css("margin", "");
        $img.css("float", "");
        $img.css("display", "");
        $img.css("z-index", "");
        $img.css("position", "");
        $img.css("overflow", "");
        $img.css("vertical-align", "");
      }
    }
    /**
     * Refresh the image list.
     */


    function _refreshImageList() {
      var images = editor.$el.get(0).tagName == "IMG" ? [editor.$el.get(0)] : editor.$el.get(0).querySelectorAll("img");

      for (var i = 0; i < images.length; i++) {
        var $img = $(images[i]);

        if (editor.opts.cpImage.imageEditButtons.indexOf("cpImageAlign") >= 0 || editor.opts.cpImage.imageEditButtons.indexOf("cpImageDisplay") >= 0) {
          _convertStyleToClasses($img);
        } // Set width if it has width.


        if ($img.attr("width")) {
          $img.css("width", $img.width());
          $img.removeAttr("width");
        } // Do not allow text near image.


        if (!editor.opts.cpImage.imageTextNear) {
          $img.removeClass("fr-dii").addClass("fr-dib");
        }

        if (editor.opts.iframe) {
          $img.on("load", editor.size.syncIframe);
        }
      }
    }
    /**
     * Keep images in sync when content changed.
     */


    var images;

    function _syncImages() {
      // Get current images.
      var c_images = Array.prototype.slice.call(editor.$el.get(0).querySelectorAll("img")); // Current images src.

      var image_srcs = [];
      var i;

      for (i = 0; i < c_images.length; i++) {
        image_srcs.push(c_images[i].getAttribute("src"));
        $(c_images[i]).toggleClass("fr-draggable", editor.opts.cpImage.imageMove);
        if (c_images[i].className === "") c_images[i].removeAttribute("class");
        if (c_images[i].getAttribute("style") === "") c_images[i].removeAttribute("style");
      } // Loop previous images and check their src.


      if (images) {
        for (i = 0; i < images.length; i++) {
          if (image_srcs.indexOf(images[i].getAttribute("src")) < 0) {
            editor.events.trigger("cpImage.removed", [$(images[i])]);
          }
        }
      } // Current images are the old ones.


      images = c_images;
    }
    /**
     * Reposition resizer.
     */


    function _repositionResizer() {
      if (!$image_resizer) _initImageResizer();
      var $container = editor.$wp || $(editor.opts.scrollableContainer);
      $container.append($image_resizer[0]);
      $image_resizer.data("instance", editor);
      var wrap_correction_top = $container.scrollTop() - ($container.css("position") != "static" ? $container.offset().top : 0);
      var wrap_correction_left = $container.scrollLeft() - ($container.css("position") != "static" ? $container.offset().left : 0);
      wrap_correction_left -= editor.helpers.getPX($container.css("border-left-width"));
      wrap_correction_top -= editor.helpers.getPX($container.css("border-top-width"));
      $image_resizer.css("top", (editor.opts.iframe ? $current_image.offset().top : $current_image.offset().top + wrap_correction_top) - 1).css("left", (editor.opts.iframe ? $current_image.offset().left : $current_image.offset().left + wrap_correction_left) - 1).css("width", $current_image.get(0).getBoundingClientRect().width).css("height", $current_image.get(0).getBoundingClientRect().height).addClass("fr-active");
    }
    /**
     * Create resize handler.
     */


    function _getHandler(pos) {
      return '<div class="fr-handler fr-h' + pos + '"></div>';
    }
    /**
     * Mouse down to start resize.
     */


    function _handlerMousedown(e) {
      // Check if resizer belongs to current instance.
      if (!editor.core.sameInstance($image_resizer)) return true;
      e.preventDefault();
      e.stopPropagation();
      if (editor.$el.find("img.fr-error").left) return false;
      if (!editor.undo.canDo()) editor.undo.saveStep();
      $handler = $(this);
      $handler.data("start-x", e.pageX || e.originalEvent.touches[0].pageX);
      $handler.data("start-width", $current_image.width());
      $handler.data("start-height", $current_image.height()); // Set current width.

      var width = $current_image.width();

      if (editor.opts.cpImage.imageResizeWithPercent) {
        var p_node = $current_image.parentsUntil(editor.$el, editor.html.blockTagsQuery()).get(0) || editor.$el.get(0);
        $current_image.css("width", (width / $(p_node).outerWidth() * 100).toFixed(2) + "%");
      } else {
        $current_image.css("width", width);
      }

      $overlay.show();
      editor.popups.hideAll();

      _unmarkExit();
    }
    /**
     * Do resize.
     */


    function _handlerMousemove(e) {
      // Check if resizer belongs to current instance.
      if (!editor.core.sameInstance($image_resizer)) return true;

      if ($handler && $current_image) {
        e.preventDefault();
        if (editor.$el.find("img.fr-error").left) return false;
        var c_x = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null);

        if (!c_x) {
          return false;
        }

        var s_x = $handler.data("start-x");
        var diff_x = c_x - s_x;
        var width = $handler.data("start-width");

        if ($handler.hasClass("fr-hnw") || $handler.hasClass("fr-hsw")) {
          diff_x = 0 - diff_x;
        }

        if (editor.opts.cpImage.imageResizeWithPercent) {
          var p_node = $current_image.parentsUntil(editor.$el, editor.html.blockTagsQuery()).get(0) || editor.$el.get(0);
          width = ((width + diff_x) / $(p_node).outerWidth() * 100).toFixed(2);
          if (editor.opts.cpImage.imageRoundPercent) width = Math.round(width);
          $current_image.css("width", width + "%");
          $current_image.css("height", "").removeAttr("height");
        } else {
          if (width + diff_x >= editor.opts.cpImage.imageMinWidth) {
            $current_image.css("width", width + diff_x);
          }

          $current_image.css("height", $handler.data("start-height") * $current_image.width() / $handler.data("start-width"));
        }

        _repositionResizer();

        editor.events.trigger("cpImage.resize", [get()]);
      }
    }
    /**
     * Stop resize.
     */


    function _handlerMouseup(e) {
      // Check if resizer belongs to current instance.
      if (!editor.core.sameInstance($image_resizer)) return true;

      if ($handler && $current_image) {
        if (e) e.stopPropagation();
        if (editor.$el.find("img.fr-error").left) return false;
        $handler = null;
        $overlay.hide();

        _repositionResizer();

        _showEditPopup();

        editor.undo.saveStep();
        editor.events.trigger("cpImage.resizeEnd", [get()]);
      }
    }
    /**
     * Throw an image error.
     */


    function _throwError(code, response) {
      editor.edit.on();
      if ($current_image) $current_image.addClass("fr-error");

      _showErrorMessage(editor.language.translate("Something went wrong. Please try again."));

      editor.events.trigger("cpImage.error", [{
        code: code,
        message: error_messages[code]
      }, response]);
    }
    /**
     * Init the image edit popup.
     */


    function _initEditPopup(delayed) {
      if (delayed) {
        if (editor.$wp) {
          editor.events.$on(editor.$wp, "scroll", function () {
            if ($current_image && editor.popups.isVisible("cpImage.edit")) {
              _showEditPopup();
            }
          });
        }

        return true;
      } // Image buttons.


      var image_buttons = "";
      var editButtons = editor.opts.cpImage.imageEditButtons;

      if (editor.opts.cpImage.imageEditButtons.length > 0) {
        image_buttons += '<div class="fr-buttons">';
        image_buttons += editor.button.buildList(editButtons);
        image_buttons += "</div>";
      }

      var template = {
        buttons: image_buttons
      };
      var $popup = editor.popups.create("cpImage.edit", template);
      return $popup;
    }
    /**
     * Hide progress bar.
     */


    function hideProgressBar(dismiss) {
      var $popup = editor.popups.get("cpImage.insert");

      if ($popup) {
        $popup.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive");
        $popup.find(".fr-image-progress-bar-layer").removeClass("fr-active");
        $popup.find(".fr-buttons").show(); // Dismiss error message.

        if (dismiss || editor.$el.find("img.fr-error").length) {
          editor.events.focus();
          editor.$el.find("img.fr-error").remove();
          editor.undo.saveStep();
          editor.undo.run();
          editor.undo.dropRedo();
        }
      }
    }
    /**
     * Set a progress message.
     */


    function _setProgressMessage(message, progress) {
      var $popup = editor.popups.get("cpImage.insert");

      if ($popup) {
        var $layer = $popup.find(".fr-image-progress-bar-layer");
        $layer.find("h3").text(message + (progress ? " " + progress + "%" : ""));
        $layer.removeClass("fr-error");

        if (progress) {
          $layer.find("div").removeClass("fr-indeterminate");
          $layer.find("div > span").css("width", progress + "%");
        } else {
          $layer.find("div").addClass("fr-indeterminate");
        }
      }
    }
    /**
     * Show progress bar.
     */


    function showProgressBar(no_message) {
      var $popup = editor.popups.get("cpImage.insert");
      if (!$popup) $popup = _initInsertPopup();
      $popup.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive");
      $popup.find(".fr-image-progress-bar-layer").addClass("fr-active");
      $popup.find(".fr-buttons").hide();

      if ($current_image) {
        editor.popups.setContainer("cpImage.insert", $(editor.opts.scrollableContainer));
        var left = $current_image.offset().left + $current_image.width() / 2;
        var top = $current_image.offset().top + $current_image.height();
        editor.popups.show("cpImage.insert", left, top, $current_image.outerHeight());
      }

      if (typeof no_message == "undefined") {
        _setProgressMessage("Uploading", 0);
      }
    }
    /**
     * Show error message to the user.
     */


    function _showErrorMessage(message) {
      showProgressBar();
      var $popup = editor.popups.get("cpImage.insert");
      var $layer = $popup.find(".fr-image-progress-bar-layer");
      $layer.addClass("fr-error");
      $layer.find("h3").text(message);
    }
    /**
     * Insert image using URL callback.
     */


    function insertByURL(href, altText) {
      showInsertPopup();
      showProgressBar();
      var $popup = editor.popups.get("cpImage.insert");
      var $input = $popup.find(".fr-image-by-url-layer input");

      _setProgressMessage("Loading image");

      insert(href, true, [], $current_image, altText);
      $input.val("");
      $input.blur();
    }

    function _editImg($img) {
      _edit.call($img.get(0));
    }

    function _loadedCallback() {
      var $img = $(this);
      editor.popups.hide("cpImage.insert");
      $img.removeClass("fr-uploading"); // Select the image.

      if ($img.next().is("br")) {
        $img.next().remove();
      }

      _editImg($img);

      editor.events.trigger("cpImage.loaded", [$img]);
    }
    /**
     * Insert image into the editor.
     */


    function insert(link, sanitize, data, $existing_img, altText, response) {
      editor.edit.off();

      _setProgressMessage("Loading image");

      if (sanitize) link = editor.helpers.sanitizeURL(link);
      var image = new Image();

      image.onload = function () {
        var $img;
        var attr;

        if ($existing_img) {
          var old_src = $existing_img.data("fr-old-src");

          if (editor.$wp) {
            // Clone existing image.
            $img = $existing_img.clone().removeData("fr-old-src").removeClass("fr-uploading"); // Remove load event.

            $img.off("load"); // Set new SRC.

            if (old_src) $existing_img.attr("src", old_src); // Replace existing image with its clone.

            $existing_img.replaceWith($img);
          } else {
            $img = $existing_img;
          } // Remove old data.


          var atts = $img.get(0).attributes;

          for (var i = 0; i < atts.length; i++) {
            var att = atts[i];

            if (att.nodeName.indexOf("data-") === 0) {
              $img.removeAttr(att.nodeName);
            }
          } // Set new data.


          if (typeof data != "undefined") {
            for (attr in data) {
              if (data.hasOwnProperty(attr)) {
                if (attr != "link") {
                  $img.attr("data-" + attr, data[attr]);
                }
              }
            }
          }

          $img.on("load", _loadedCallback);
          $img.attr("alt", altText);
          $img.attr("src", link);
          editor.edit.on();

          _syncImages();

          editor.undo.saveStep();
          editor.events.trigger(old_src ? "cpImage.replaced" : "cpImage.inserted", [$img, response]);
        } else {
          $img = _addImage(link, data, _loadedCallback, altText);

          _syncImages();

          editor.undo.saveStep();
          editor.events.trigger("cpImage.inserted", [$img, response]);
        }
      };

      image.onerror = function () {
        _throwError(BAD_LINK);
      };

      image.src = link;
    }
    /**
     * Parse image response.
     */


    function _parseResponse(response) {
      try {
        if (editor.events.trigger("cpImage.uploaded", [response], true) === false) {
          editor.edit.on();
          return false;
        }

        var resp = parseJSON(response);

        if (resp.link) {
          return resp;
        } else {
          // No link in upload request.
          _throwError(MISSING_LINK, response);

          return false;
        }
      } catch (ex) {
        // Bad response.
        _throwError(BAD_RESPONSE, response);

        return false;
      }
    }

    function _addImage(link, data, loadCallback, altText) {
      // Build image data string.
      var data_str = "";
      var attr;

      if (data && typeof data != "undefined") {
        for (attr in data) {
          if (data.hasOwnProperty(attr)) {
            if (attr != "link") {
              data_str += " data-" + attr + '="' + data[attr] + '"';
            }
          }
        }
      }

      var width = editor.opts.cpImage.imageDefaultWidth;

      if (width && width != "auto") {
        width = width + (editor.opts.cpImage.imageResizeWithPercent ? "%" : "px");
      } // Create image object and set the load event.


      var blocks = editor.selection.blocks();
      var alignment = blocks.length ? editor.helpers.getAlignment($(blocks[0])) : editor.opts.cpImage.imageDefaultAlign;
      var $img = $('<img class="' + (editor.opts.cpImage.imageDefaultDisplay ? "fr-di" + editor.opts.cpImage.imageDefaultDisplay[0] : "") + (alignment ? alignment != "center" ? " fr-fi" + alignment[0] : "" : "") + '" src="' + link + '"' + data_str + (width ? ' style="width: ' + width + ';"' : "") + (altText ? ' alt="' + altText + '"' : "") + ">");
      $img.on("load", loadCallback); // Make sure we have focus.
      // Call the event.

      editor.edit.on();
      editor.events.focus(true);
      editor.selection.restore();
      editor.undo.saveStep(); // Insert marker and then replace it with the image.

      if (editor.opts.cpImage.imageSplitHTML) {
        editor.markers.split();
      } else {
        editor.markers.insert();
      }

      var $marker = editor.$el.find(".fr-marker");
      $marker.replaceWith($img);
      editor.html.wrap();
      editor.selection.clear();
      return $img;
    }

    function _placeCursor() {
      var t;
      var p_node;
      var r = editor.selection.ranges(0);

      if (r.collapsed && r.startContainer.nodeType == Node.ELEMENT_NODE) {
        // Click after image.
        if (r.startContainer.childNodes.length == r.startOffset) {
          t = r.startContainer.childNodes[r.startOffset - 1];

          if (t && t.tagName == "IMG" && $(t).css("display") == "block") {
            // Check if image is last node.
            p_node = editor.node.blockParent(t);

            if (p_node && editor.html.defaultTag()) {
              if (!p_node.nextSibling) {
                if (["TD", "TH"].indexOf(p_node.tagName) < 0) {
                  $(p_node).after("<" + editor.html.defaultTag() + "><br>" + FE.MARKERS + "</" + editor.html.defaultTag() + ">");
                } else {
                  $(img).after("<br>" + FE.MARKERS);
                }

                editor.selection.restore();
              }
            } else if (!p_node) {
              $(t).after("<br>" + FE.MARKERS);
              editor.selection.restore();
            }
          }
        } else if (r.startOffset === 0 && r.startContainer.childNodes.length > r.startOffset) {
          t = r.startContainer.childNodes[r.startOffset];

          if (t && t.tagName == "IMG" && $(t).css("display") == "block") {
            // Check if image is last node.
            p_node = editor.node.blockParent(t);

            if (p_node && editor.html.defaultTag()) {
              if (!p_node.previousSibling) {
                if (["TD", "TH"].indexOf(p_node.tagName) < 0) {
                  $(p_node).before("<" + editor.html.defaultTag() + "><br>" + FE.MARKERS + "</" + editor.html.defaultTag() + ">");
                } else {
                  $(img).before("<br>" + FE.MARKERS);
                }

                editor.selection.restore();
              }
            } else if (!p_node) {
              $(t).before(FE.MARKERS + "<br>");
              editor.selection.restore();
            }
          }
        }
      }
    }

    function _initEvents() {
      // Mouse down on image. It might start move.
      editor.events.$on(editor.$el, editor._mousedown, editor.$el.get(0).tagName == "IMG" ? null : 'img:not([contenteditable="false"]):not([src*="blob"]) ', function (e) {
        if ($(this).parents('[contenteditable="false"]:not(.fr-element):not(body)').length) return true;
        editor.selection.clear();
        mousedown = true; // Prevent the image resizing.

        if (editor.browser.msie) {
          editor.events.disableBlur();
          editor.$el.attr("contenteditable", false);
        }

        if (!editor.draggable) e.preventDefault();
        e.stopPropagation();
      }); // Mouse up on an image prevent move.

      editor.events.$on(editor.$el, editor._mouseup, editor.$el.get(0).tagName == "IMG" ? null : 'img:not([contenteditable="false"]):not([src*="blob"])', function (e) {
        if ($(this).parents('[contenteditable="false"]:not(.fr-element):not(body)').length) return true;

        if (mousedown) {
          mousedown = false; // Remove moving class.

          e.stopPropagation();

          if (editor.browser.msie) {
            editor.$el.attr("contenteditable", true);
            editor.events.enableBlur();
          }
        }
      }); // Show image popup when it was selected.

      editor.events.on("keyup", function (e) {
        if (e.shiftKey && editor.selection.text().replace(/\n/g, "") === "") {
          var s_el = editor.selection.element();
          var e_el = editor.selection.endElement();

          if (s_el && s_el.tagName == "IMG") {
            _editImg($(s_el));
          } else if (e_el && e_el.tagName == "IMG") {
            _editImg($(e_el));
          }
        }
      }, true);
      editor.events.on("mousedown window.mousedown", _markExit);
      editor.events.on("window.touchmove", _unmarkExit);
      editor.events.on("mouseup window.mouseup", function () {
        if ($current_image) {
          _exitEdit();

          return false;
        }
      });
      editor.events.on("commands.mousedown", function ($btn) {
        if ($btn.parents(".fr-toolbar").length > 0) {
          _exitEdit();
        }
      });
      editor.events.on("mouseup", _placeCursor);
      editor.events.on("blur image.hideResizer commands.undo commands.redo element.dropped", function () {
        mousedown = false;

        _exitEdit(true);
      });
    }
    /**
     * Init the image upload popup.
     */


    function _initInsertPopup(delayed) {
      if (delayed) {
        editor.popups.onRefresh("cpImage.insert", _refreshInsertPopup);
        editor.popups.onHide("cpImage.insert", _hideInsertPopup);
        return true;
      } // Image buttons.


      var image_buttons = "";

      if (editor.opts.cpImage.imageInsertButtons.length > 1) {
        image_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.cpImage.imageInsertButtons) + "</div>";
      } // Progress bar.


      var progress_bar_layer = '<div class="fr-image-progress-bar-layer fr-layer"><h3 class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-back" data-cmd="cpImageDismissError" tabIndex="2">OK</button></div></div>';
      var template = {
        buttons: image_buttons,
        progress_bar: progress_bar_layer
      }; // Set the template in the popup.

      var $popup = editor.popups.create("cpImage.insert", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll", function () {
          if ($current_image && editor.popups.isVisible("cpImage.insert")) {
            replace();
          }
        });
      }

      return $popup;
    }
    /**
     * Refresh the ALT popup.
     */


    function _refreshAltPopup() {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.alt");
        $popup.find("input").val($current_image.attr("alt") || "").trigger("change");
      }
    }
    /**
     * Show the ALT popup.
     */


    function showAltPopup() {
      var $popup = editor.popups.get("cpImage.alt");
      if (!$popup) $popup = _initAltPopup();
      hideProgressBar();
      editor.popups.refresh("cpImage.alt");
      editor.popups.setContainer("cpImage.alt", $(editor.opts.scrollableContainer));
      var left = $current_image.offset().left + $current_image.width() / 2;
      var top = $current_image.offset().top + $current_image.height();
      editor.popups.show("cpImage.alt", left, top, $current_image.outerHeight());
    }
    /**
     * Init the image upload popup.
     */


    function _initAltPopup(delayed) {
      if (delayed) {
        editor.popups.onRefresh("cpImage.alt", _refreshAltPopup);
        return true;
      } // Image buttons.


      var image_buttons = "";
      image_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.cpImage.imageAltButtons) + "</div>"; // Image by url layer.

      var alt_layer = "";
      alt_layer = '<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-' + editor.id + '"><div class="fr-input-line"><input type="text" placeholder="' + editor.language.translate("Alternate Text") + '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="cpImageSetAlt" tabIndex="2">' + editor.language.translate("Update") + "</button></div></div>";
      var template = {
        buttons: image_buttons,
        alt_layer: alt_layer
      }; // Set the template in the popup.

      var $popup = editor.popups.create("cpImage.alt", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.image-alt", function () {
          if ($current_image && editor.popups.isVisible("cpImage.alt")) {
            showAltPopup();
          }
        });
      }

      return $popup;
    }
    /**
     * Set ALT based on the values from the popup.
     */


    function setAlt(alt) {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.alt");
        $current_image.attr("alt", alt || $popup.find("input").val() || "");
        $popup.find("input:focus").blur();

        _editImg($current_image);
      }
    } //Sets the link on image


    function setLink(linkValue, newWindow) {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.link");
        var check_inputs = $popup.find('input.fr-link-attr[type="checkbox"]');
        var $img = "";
        var attrs = "";
        if (newWindow) attrs = 'rel="noopener noreferrer" target="_blank"';

        if (window.isIE11()) {
          $img = $(".selectedFroalaImage");
        } else {
          $img = $current_image;
        }

        if ($img.parent("a").length == 0) $img.wrap('<a href="' + linkValue + '" ' + attrs + "></a>");else $img.unwrap("a").wrap('<a href="' + linkValue + '" ' + attrs + "></a>");
        var $input;

        for (var i = 0; i < check_inputs.length; i++) {
          $input = $(check_inputs[i]);

          if (newWindow) {
            $input.attr("checked", true);
          }
        }

        $popup.find("input:focus").blur();

        _editImg($img);
      }
    } //Opens the image link


    function openLink() {
      if ($current_image) {
        var url = "";

        if (window.isIE11()) {
          url = $(".selectedFroalaImage").parent("a").attr("href");

          _editImg($(".selectedFroalaImage"));
        } else {
          url = $current_image.parent("a").attr("href");

          _editImg($current_image);
        }

        window.open(url, "_blank");
      }
    } //Removes the image link


    function removeLink() {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.link");
        var $img = "";

        if (window.isIE11()) {
          $img = $(".selectedFroalaImage");
        } else {
          $img = $current_image;
        }

        $img.unwrap("a");

        if ($popup != undefined) {
          $popup.find('input[name="href"]').val("");
          $popup.find('input[name="target"]').val("checked", false);
        }

        _editImg($img);
      }
    }
    /**
     * Refresh the size popup.
     */


    function _refreshSizePopup() {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.size");
        $popup.find('input[name="width"]').val($current_image.get(0).style.width).trigger("change");
        $popup.find('input[name="height"]').val($current_image.get(0).style.height).trigger("change");
      }
    }

    function _refreshLinkPopup() {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.link");
        var $parent = $current_image.parent("a");
        var linkValue = "";
        var newWindow = false;

        if ($parent.length > 0) {
          linkValue = $parent.attr("href");
          var isHttp = /^http:.*/i.test(linkValue);
          var isHttps = /^https:.*/i.test(linkValue);
          var hasMailTo = /^mailto:.*/i.test(linkValue);
          var validEmail = emailValidate(linkValue);
          var relativeLink = linkValue.startsWith("/");

          if (!relativeLink) {
            if (!isHttp && !isHttps && !emailValidate(linkValue) && !hasMailTo) linkValue = "http://" + linkValue;else if (emailValidate(linkValue) && !hasMailTo) linkValue = "mailto:" + linkValue;
          }

          newWindow = $parent.attr("target") == "_blank";
        }

        var check_inputs = $popup.find('input.fr-link-attr[type="checkbox"]');
        var i;
        var $input;

        for (i = 0; i < check_inputs.length; i++) {
          $input = $(check_inputs[i]);

          if (newWindow) {
            $input.attr("checked", true);
          }
        }

        $popup.find('input[name="href"]').val(linkValue).trigger("change");
        $popup.find('input[name="target"]').val("checked", newWindow);
      }
    }
    /**
     * Show the size popup.
     */


    function showSizePopup() {
      var $popup = editor.popups.get("cpImage.size");
      if (!$popup) $popup = _initSizePopup();
      hideProgressBar();
      editor.popups.refresh("cpImage.size");
      editor.popups.setContainer("cpImage.size", $(editor.opts.scrollableContainer));
      var left = $current_image.offset().left + $current_image.width() / 2;
      var top = $current_image.offset().top + $current_image.height();
      editor.popups.show("cpImage.size", left, top, $current_image.outerHeight());
    }
    /**
     * Init the image upload popup.
     */


    function _initSizePopup(delayed) {
      if (delayed) {
        editor.popups.onRefresh("cpImage.size", _refreshSizePopup);
        return true;
      } // Image buttons.


      var image_buttons = "";
      image_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.cpImage.imageSizeButtons) + "</div>"; // Size layer.

      var size_layer = "";
      size_layer = '<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-' + editor.id + '"><div class="fr-image-group"><div class="fr-input-line"><input type="text" name="width" placeholder="' + editor.language.translate("Width") + '" tabIndex="1"></div><div class="fr-input-line"><input type="text" name="height" placeholder="' + editor.language.translate("Height") + '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="cpImageSetSize" tabIndex="2">' + editor.language.translate("Update") + "</button></div></div>";
      var template = {
        buttons: image_buttons,
        size_layer: size_layer
      }; // Set the template in the popup.

      var $popup = editor.popups.create("cpImage.size", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.image-size", function () {
          if ($current_image && editor.popups.isVisible("cpImage.size")) {
            showSizePopup();
          }
        });
      }

      return $popup;
    }

    function _initLinkPopup(delayed, isEditPopup) {
      if (delayed) {
        editor.popups.onRefresh("cpImage.link", _refreshLinkPopup);
        return true;
      } // Image buttons.


      var link_buttons = "";
      link_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.cpImage.imageLinkButtons) + "</div>"; // Size layer.

      var link_layer = "";
      var saveBtnText = isEditPopup ? "Update" : "Insert";
      link_layer = '<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-' + editor.id + '"><div class="fr-input-line"><input id="fr-link-insert-layer-url-1" name="href" type="text" class="fr-link-attr" tabindex="1" dir="auto"><label for="fr-link-insert-layer-url-1">Link</label></div><div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr fr-not-empty" data-checked="_blank" type="checkbox" id="fr-link-target-' + editor.id + '" tabindex="3" dir="auto"><span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg></span></span><label for="fr-link-target-1">Open in new tab</label></div><div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="cpImageSetLink" href="#" tabindex="4" type="button">' + saveBtnText + "</button></div></div>";
      var template = {
        buttons: link_buttons,
        link_layer: link_layer
      }; // Set the template in the popup.

      var $popup = editor.popups.create("cpImage.link", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.image-size", function () {
          if ($current_image && editor.popups.isVisible("cpImage.link")) {
            showLinkPopup(false);
          }
        });
      }

      return $popup;
    }

    function showLinkPopup(isEditPopup) {
      var $popup = _initLinkPopup(false, isEditPopup);

      hideProgressBar();
      editor.popups.refresh("cpImage.link");
      editor.popups.setContainer("cpImage.link", $(editor.opts.scrollableContainer));
      var left = $current_image.offset().left + $current_image.width() / 2;
      var top = $current_image.offset().top + $current_image.height();
      editor.popups.show("cpImage.link", left, top, $current_image.outerHeight());
    }
    /**
     * Set size based on the current image size.
     */


    function setSize(width, height) {
      if ($current_image) {
        var $popup = editor.popups.get("cpImage.size");
        $current_image.css("width", width || $popup.find('input[name="width"]').val());
        $current_image.css("height", height || $popup.find('input[name="height"]').val());
        $popup.find("input:focus").blur();

        _editImg($current_image);
      }
    }
    /**
     * Show the image upload layer.
     */


    function showLayer(name) {
      var $popup = editor.popups.get("cpImage.insert");
      var left;
      var top; // Click on the button from the toolbar without image selected.

      if (!$current_image && !editor.opts.toolbarInline) {
        var $btn = editor.$tb.find('.fr-command[data-cmd="cpImage"]');
        left = $btn.offset().left + $btn.outerWidth() / 2;
        top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
      } // Image is selected.
      else if ($current_image) {
          // Set the top to the bottom of the image.
          top = $current_image.offset().top + $current_image.outerHeight();
        } // Image is selected and we are in inline mode.


      if (!$current_image && editor.opts.toolbarInline) {
        // Set top to the popup top.
        top = $popup.offset().top - editor.helpers.getPX($popup.css("margin-top")); // If the popup is above apply height correction.

        if ($popup.hasClass("fr-above")) {
          top += $popup.outerHeight();
        }
      } // Show the new layer.


      $popup.find(".fr-layer").removeClass("fr-active");
      $popup.find(".fr-" + name + "-layer").addClass("fr-active");
      editor.popups.show("cpImage.insert", left, top, $current_image ? $current_image.outerHeight() : 0);
    }
    /**
     * Refresh the upload image button.
     */


    function refreshUploadButton($btn) {
      var $popup = editor.popups.get("cpImage.insert");

      if ($popup.find(".fr-image-upload-layer").hasClass("fr-active")) {
        $btn.addClass("fr-active");
      }
    }
    /**
     * Refresh the insert by url button.
     */


    function refreshByURLButton($btn) {
      var $popup = editor.popups.get("cpImage.insert");

      if ($popup.find(".fr-image-by-url-layer").hasClass("fr-active")) {
        $btn.addClass("fr-active");
      }
    }
    /**
     * Init image resizer.
     */


    function _initImageResizer() {
      var doc; // No shared image resizer.

      if (!editor.shared.$image_resizer) {
        // Create shared image resizer.
        editor.shared.$image_resizer = $('<div class="fr-image-resizer"></div>');
        $image_resizer = editor.shared.$image_resizer; // Bind mousedown event shared.

        editor.events.$on($image_resizer, "mousedown", function (e) {
          e.stopPropagation();
        }, true); // Image resize is enabled.

        if (editor.opts.cpImage.imageResize) {
          $image_resizer.append(_getHandler("nw") + _getHandler("ne") + _getHandler("sw") + _getHandler("se")); // Add image resizer overlay and set it.

          editor.shared.$img_overlay = $('<div class="fr-image-overlay"></div>');
          $overlay = editor.shared.$img_overlay;
          doc = $image_resizer.get(0).ownerDocument;
          $(doc).find("body").append($overlay);
        }
      } else {
        $image_resizer = editor.shared.$image_resizer;
        $overlay = editor.shared.$img_overlay;
        editor.events.on("destroy", function () {
          if ($image_resizer.hasClass("fr-active")) {
            $image_resizer.removeClass("fr-active").appendTo($("body"));
          }
        }, true);
      } // Shared destroy.


      editor.events.on("shared.destroy", function () {
        $image_resizer.html("").removeData().remove();
        $image_resizer = null;

        if (editor.opts.cpImage.imageResize) {
          $overlay.remove();
          $overlay = null;
        }
      }, true); // Window resize. Exit from edit.

      if (!editor.helpers.isMobile()) {
        editor.events.$on($(editor.o_win), "resize", function () {
          if ($current_image && !$current_image.hasClass("fr-uploading")) {
            _exitEdit(true);
          } else if ($current_image) {
            _repositionResizer();

            replace();
            showProgressBar(false);
          }
        });
      } // Image resize is enabled.


      if (editor.opts.cpImage.imageResize) {
        doc = $image_resizer.get(0).ownerDocument;
        editor.events.$on($image_resizer, editor._mousedown, ".fr-handler", _handlerMousedown);
        editor.events.$on($(doc), editor._mousemove, _handlerMousemove);
        editor.events.$on($(doc.defaultView || doc.parentWindow), editor._mouseup, _handlerMouseup);
        editor.events.$on($overlay, "mouseleave", _handlerMouseup);
      }
    }
    /**
     * Remove the current image.
     */


    function remove($img) {
      $img = $img || $current_image;

      if ($img) {
        if (editor.events.trigger("cpImage.beforeRemove", [$img]) !== false) {
          editor.popups.hideAll();

          _exitEdit(true);

          if ($img.get(0) == editor.$el.get(0)) {
            $img.removeAttr("src");
          } else {
            if ($img.get(0).parentNode.tagName == "A") {
              editor.selection.setBefore($img.get(0).parentNode) || editor.selection.setAfter($img.get(0).parentNode) || $img.parent().after(FE.MARKERS);
              $($img.get(0).parentNode).remove();
            } else {
              editor.selection.setBefore($img.get(0)) || editor.selection.setAfter($img.get(0)) || $img.after(FE.MARKERS);
              $img.remove();
            }

            editor.html.fillEmptyBlocks();
            editor.selection.restore();
          }

          editor.undo.saveStep();
        }
      }
    }
    /**
     * Initialization.
     */


    function _init() {
      _initEvents(); // Init on image.


      if (editor.$el.get(0).tagName == "IMG") {
        editor.$el.addClass("fr-view");
      }

      editor.events.$on(editor.$el, editor.helpers.isMobile() && !editor.helpers.isWindowsPhone() ? "touchend" : "click", editor.$el.get(0).tagName == "IMG" ? null : 'img:not([contenteditable="false"]):not([src*="blob"])', _edit);

      if (editor.helpers.isMobile()) {
        editor.events.$on(editor.$el, "touchstart", editor.$el.get(0).tagName == "IMG" ? null : 'img:not([contenteditable="false"]):not([src*="blob"])', function () {
          touchScroll = false;
        });
        editor.events.$on(editor.$el, "touchmove", function () {
          touchScroll = true;
        });
      }

      editor.events.on("window.keydown keydown", function (e) {
        var key_code = e.which;

        if ($current_image && (key_code == FE.KEYCODE.BACKSPACE || key_code == FE.KEYCODE.DELETE)) {
          e.preventDefault();
          e.stopPropagation();
          remove();
          return false;
        }

        if ($current_image && key_code == FE.KEYCODE.ESC) {
          var $img = $current_image;

          _exitEdit(true);

          editor.selection.setAfter($img.get(0));
          editor.selection.restore();
          e.preventDefault();
          return false;
        }

        if ($current_image && !editor.keys.ctrlKey(e)) {
          e.preventDefault();
          return false;
        }
      }, true); // Copy/cut image.

      editor.events.on("window.cut window.copy", function (e) {
        if ($current_image) {
          _selectImage();

          FE.copied_text = "\n";
          FE.copied_html = $current_image.get(0).outerHTML;

          if (e.type == "copy") {
            setTimeout(function () {
              _editImg($current_image);
            });
          } else {
            _exitEdit(true);

            editor.undo.saveStep();
            setTimeout(function () {
              editor.undo.saveStep();
            }, 0);
          }
        }
      }, true); // Do not leave page while uploading.

      editor.events.$on($(editor.o_win), "keydown", function (e) {
        var key_code = e.which;

        if ($current_image && key_code == FE.KEYCODE.BACKSPACE) {
          e.preventDefault();
          return false;
        }
      }); // Check if image is uploading to abort it.

      editor.events.$on(editor.$win, "keydown", function (e) {
        var key_code = e.which;

        if ($current_image && $current_image.hasClass("fr-uploading") && key_code == FE.KEYCODE.ESC) {
          $current_image.trigger("abortUpload");
        }
      });
      editor.events.on("destroy", function () {
        if ($current_image && $current_image.hasClass("fr-uploading")) {
          $current_image.trigger("abortUpload");
        }
      });
      editor.events.on("html.set", _refreshImageList);
      editor.events.on("html.inserted", _refreshImageList);

      _refreshImageList();

      editor.events.on("destroy", function () {
        images = [];
      });
      editor.events.on("html.get", function (html) {
        html = html.replace(/<(img)((?:[\w\W]*?))class="([\w\W]*?)(fr-uploading|fr-error)([\w\W]*?)"((?:[\w\W]*?))>/g, "");
        return html;
      });

      if (editor.opts.cpImage.imageOutputSize) {
        var imgs;
        editor.events.on("html.beforeGet", function () {
          imgs = editor.$el.get(0).querySelectorAll("img");

          for (var i = 0; i < imgs.length; i++) {
            imgs[i].setAttribute("width", $(imgs[i]).width());
            imgs[i].setAttribute("height", $(imgs[i]).height());
          }
        });
        editor.events.on("html.afterGet", function () {
          for (var i = 0; i < imgs.length; i++) {
            imgs[i].removeAttribute("width");
            imgs[i].removeAttribute("height");
          }
        });
      }

      if (editor.opts.iframe) {
        editor.events.on("cpImage.loaded", editor.size.syncIframe);
      }

      if (editor.$wp) {
        _syncImages();

        editor.events.on("contentChanged", _syncImages);
      }

      editor.events.$on($(editor.o_win), "orientationchange.image", function () {
        setTimeout(function () {
          var $current_image = get();

          if ($current_image) {
            _editImg($current_image);
          }
        }, 0);
      });

      _initEditPopup(true);

      _initInsertPopup(true);

      _initSizePopup(true);

      _initLinkPopup(true, false);

      _initAltPopup(true);

      $('.fr-command[data-cmd="insertLink"]').click(function () {
        //Remove applied z-index for inner div columns
        $("div.inner.col").each(function (index, element) {
          if ($(element).css("z-index") == "1000") {
            $(element).css({
              "z-index": ""
            });
          }
        }); //Apply z-index to the current froala div column

        $(this).parents("div.inner.col").css({
          "z-index": "1000"
        });
      });
      editor.events.on("node.remove", function ($node) {
        if ($node.get(0).tagName == "IMG") {
          remove($node);
          return false;
        }
      });
    }
    /**
     * Start edit.
     */


    var touchScroll;

    function _edit(e) {
      if ($(this).parents('[contenteditable="false"]:not(.fr-element):not(body)').length) return true;

      if (e && e.type == "touchend" && touchScroll) {
        return true;
      }

      if (e && editor.edit.isDisabled()) {
        e.stopPropagation();
        e.preventDefault();
        return false;
      } // Hide resizer for other instances.


      for (var i = 0; i < FE.INSTANCES.length; i++) {
        if (FE.INSTANCES[i] != editor) {
          FE.INSTANCES[i].events.trigger("cpImage.hideResizer");
        }
      }

      editor.toolbar.disable();

      if (e) {
        e.stopPropagation();
        e.preventDefault();
      } // Hide keyboard.


      if (editor.helpers.isMobile()) {
        editor.events.disableBlur();
        editor.$el.blur();
        editor.events.enableBlur();
      }

      if (editor.opts.iframe) {
        editor.size.syncIframe();
      }

      $current_image = $(this);

      if (window.isIE11()) {
        $(".selectedFroalaImage").removeClass("selectedFroalaImage");
        $current_image.addClass("selectedFroalaImage");
      }

      _selectImage();

      _repositionResizer();

      _showEditPopup();

      editor.selection.clear();
      editor.button.bulkRefresh();
      editor.events.trigger("video.hideResizer");
    }
    /**
     * Exit edit.
     */


    function _exitEdit(force_exit) {
      if ($current_image && (_canExit() || force_exit === true)) {
        editor.toolbar.enable();
        $image_resizer.removeClass("fr-active");
        editor.popups.hide("cpImage.edit");

        if (window.isIE11()) {
          $current_image.removeClass("selectedFroalaImage");
        }

        $current_image = null;

        _unmarkExit();
      }
    }

    var img_exit_flag = false;

    function _markExit() {
      img_exit_flag = true;
    }

    function _unmarkExit() {
      img_exit_flag = false;
    }

    function _canExit() {
      return img_exit_flag;
    }
    /**
     * Align image.
     */


    function align(val) {
      $current_image.removeClass("fr-fir fr-fil");

      if (val == "left") {
        $current_image.addClass("fr-fil");
      } else if (val == "right") {
        $current_image.addClass("fr-fir");
      }

      _repositionResizer();

      _showEditPopup();
    }
    /**
     * Refresh the align icon.
     */


    function refreshAlign($btn) {
      if ($current_image) {
        if ($current_image.hasClass("fr-fil")) {
          $btn.find("> *").first().replaceWith(editor.icon.create("align-left"));
        } else if ($current_image.hasClass("fr-fir")) {
          $btn.find("> *").first().replaceWith(editor.icon.create("align-right"));
        } else {
          $btn.find("> *").first().replaceWith(editor.icon.create("align-justify"));
        }
      }
    }
    /**
     * Refresh the align option from the dropdown.
     */


    function refreshAlignOnShow($btn, $dropdown) {
      if ($current_image) {
        var alignment = "justify";

        if ($current_image.hasClass("fr-fil")) {
          alignment = "left";
        } else if ($current_image.hasClass("fr-fir")) {
          alignment = "right";
        }

        $dropdown.find('.fr-command[data-param1="' + alignment + '"]').addClass("fr-active");
      }
    }
    /**
     * Align image.
     */


    function display(val) {
      $current_image.removeClass("fr-dii fr-dib");

      if (val == "inline") {
        $current_image.addClass("fr-dii");
      } else if (val == "block") {
        $current_image.addClass("fr-dib");
      }

      _repositionResizer();

      _showEditPopup();
    }
    /**
     * Refresh the image display selected option.
     */


    function refreshDisplayOnShow($btn, $dropdown) {
      var d = "block";

      if ($current_image.hasClass("fr-dii")) {
        d = "inline";
      }

      $dropdown.find('.fr-command[data-param1="' + d + '"]').addClass("fr-active");
    }
    /**
     * Opens cpModal for Image Repo.
     */


    function openCpImageModal(self) {
      var image = $current_image;
      var promptUserForAssetsAsync = editor.opts.promptUserForAssetsAsync;
      promptUserForAssetsAsync({
        allowMultipleChoices: false,
        imagesOnly: true
      }).then(function (selectedImages) {
        $current_image = image;
        self.insertByURL(selectedImages[0].url || selectedImages[0].links.self.href, selectedImages[0].briefDescription);
      });
    }
    /**
     * Show the replace popup.
     */


    function replace() {
      openCpImageModal(this);
    }
    /**
     * Place selection around current image.
     */


    function _selectImage() {
      if ($current_image) {
        editor.selection.clear();
        var range = editor.doc.createRange();

        try {
          range.selectNode($current_image.get(0));
          var selection = editor.selection.get();
          selection.addRange(range);
        } catch (e) {
          _throwError(8);
        }
      }
    }
    /**
     * Get back to the image main popup.
     */


    function back() {
      if ($current_image) {
        $(".fr-popup input:focus").blur();

        _editImg($current_image);
      } else {
        editor.events.disableBlur();
        editor.selection.restore();
        editor.events.enableBlur();
        editor.popups.hide("cpImage.insert");
        editor.toolbar.showInline();
      }
    }
    /**
     * Get the current image.
     */


    function get() {
      return $current_image;
    }
    /**
     * Apply specific style.
     */


    function applyStyle(val, imageStyles, multipleStyles) {
      if (typeof imageStyles == "undefined") imageStyles = editor.opts.cpImage.imageStyles;
      if (typeof multipleStyles == "undefined") multipleStyles = editor.opts.cpImage.imageMultipleStyles;
      if (!$current_image) return false; // Remove multiple styles.

      if (!multipleStyles) {
        var styles = Object.keys(imageStyles);
        styles.splice(styles.indexOf(val), 1);
        $current_image.removeClass(styles.join(" "));
      }

      $current_image.toggleClass(val);

      _editImg($current_image);
    }

    return {
      _init: _init,
      insertImage: insertImage,
      showInsertPopup: showInsertPopup,
      showLayer: showLayer,
      refreshUploadButton: refreshUploadButton,
      refreshByURLButton: refreshByURLButton,
      insertByURL: insertByURL,
      align: align,
      refreshAlign: refreshAlign,
      refreshAlignOnShow: refreshAlignOnShow,
      display: display,
      refreshDisplayOnShow: refreshDisplayOnShow,
      replace: replace,
      back: back,
      get: get,
      insert: insert,
      showProgressBar: showProgressBar,
      remove: remove,
      hideProgressBar: hideProgressBar,
      applyStyle: applyStyle,
      showAltPopup: showAltPopup,
      showSizePopup: showSizePopup,
      showLinkPopup: showLinkPopup,
      setAlt: setAlt,
      setLink: setLink,
      openLink: openLink,
      removeLink: removeLink,
      setSize: setSize,
      exitEdit: _exitEdit,
      edit: _editImg
    };
  }; // Insert image button.


  FE.DefineIcon("cpImage", {
    NAME: "image",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImage", {
    title: "Insert Image",
    undo: false,
    focus: true,
    refreshAfterCallback: false,
    popup: true,
    callback: function callback() {
      this.cpImage.insertImage();
    }
  }); // Image upload button inside the insert image popup.

  FE.DefineIcon("cpImageUpload", {
    NAME: "upload",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageUpload", {
    title: "Upload Image",
    undo: false,
    focus: false,
    callback: function callback() {
      this.cpImage.showLayer("image-upload");
    },
    refresh: function refresh($btn) {
      this.cpImage.refreshUploadButton($btn);
    }
  }); // Image by URL button inside the insert image popup.

  FE.DefineIcon("cpImageByURL", {
    NAME: "link",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageByURL", {
    title: "By URL",
    undo: false,
    focus: false,
    callback: function callback() {
      this.cpImage.showLayer("image-by-url");
    },
    refresh: function refresh($btn) {
      this.cpImage.refreshByURLButton($btn);
    }
  }); // Insert image button inside the insert by URL layer.

  FE.RegisterCommand("cpImageInsertByURL", {
    title: "Insert Image",
    undo: true,
    refreshAfterCallback: false,
    callback: function callback() {
      this.cpImage.insertByURL();
    },
    refresh: function refresh($btn) {
      var $current_image = this.cpImage.get();

      if (!$current_image) {
        $btn.text(this.language.translate("Insert"));
      } else {
        $btn.text(this.language.translate("Replace"));
      }
    }
  }); // Image display.

  FE.DefineIcon("cpImageDisplay", {
    NAME: "star",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageDisplay", {
    title: "Display",
    type: "dropdown",
    options: {
      inline: "Inline",
      block: "Break Text"
    },
    callback: function callback(cmd, val) {
      this.cpImage.display(val);
    },
    refresh: function refresh($btn) {
      if (!this.opts.cpImage.imageTextNear) $btn.addClass("fr-hidden");
    },
    refreshOnShow: function refreshOnShow($btn, $dropdown) {
      this.cpImage.refreshDisplayOnShow($btn, $dropdown);
    }
  }); // Image align.

  if (!FE.ICONS.align) {
    FE.DefineIcon("align", {
      NAME: "align-left",
      template: "font_awesome"
    });
    FE.DefineIcon("align-left", {
      NAME: "align-left",
      template: "font_awesome"
    });
    FE.DefineIcon("align-right", {
      NAME: "align-right",
      template: "font_awesome"
    });
    FE.DefineIcon("align-center", {
      NAME: "align-center",
      template: "font_awesome"
    });
    FE.DefineIcon("align-justify", {
      NAME: "align-justify",
      template: "font_awesome"
    });
  }

  FE.DefineIcon("cpImageAlign", {
    NAME: "align-center",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageAlign", {
    type: "dropdown",
    title: "Align",
    options: {
      left: "Align Left",
      justify: "None",
      right: "Align Right"
    },
    html: function html() {
      var c = '<ul class="fr-dropdown-list">';
      var options = FE.COMMANDS.cpImageAlign.options;

      for (var val in options) {
        if (options.hasOwnProperty(val)) {
          c += '<li><a class="fr-command fr-title" data-cmd="cpImageAlign" data-param1="' + val + '" title="' + this.language.translate(options[val]) + '">' + this.icon.create("align-" + val) + "</a></li>";
        }
      }

      c += "</ul>";
      return c;
    },
    callback: function callback(cmd, val) {
      this.cpImage.align(val);
    },
    refresh: function refresh($btn) {
      this.cpImage.refreshAlign($btn);
    },
    refreshOnShow: function refreshOnShow($btn, $dropdown) {
      this.cpImage.refreshAlignOnShow($btn, $dropdown);
    }
  }); // Image replace.

  FE.DefineIcon("cpImageReplace", {
    NAME: "exchange",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageReplace", {
    title: "Replace",
    undo: false,
    focus: false,
    refreshAfterCallback: false,
    callback: function callback() {
      this.cpImage.replace();
    }
  }); // Image remove.

  FE.DefineIcon("cpImageRemove", {
    NAME: "trash",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageRemove", {
    title: "Remove",
    callback: function callback() {
      this.cpImage.remove();
    }
  }); // Image back.

  FE.DefineIcon("cpImageBack", {
    NAME: "arrow-left",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageBack", {
    title: "Back",
    undo: false,
    focus: false,
    back: true,
    callback: function callback() {
      this.cpImage.back();
    },
    refresh: function refresh($btn) {
      var $current_image = this.cpImage.get();

      if (!$current_image && !this.opts.toolbarInline) {
        $btn.addClass("fr-hidden");
        $btn.next(".fr-separator").addClass("fr-hidden");
      } else {
        $btn.removeClass("fr-hidden");
        $btn.next(".fr-separator").removeClass("fr-hidden");
      }
    }
  });
  FE.RegisterCommand("cpImageDismissError", {
    title: "OK",
    undo: false,
    callback: function callback() {
      this.cpImage.hideProgressBar(true);
    }
  }); // Image styles.

  FE.DefineIcon("cpImageStyle", {
    NAME: "magic",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageStyle", {
    title: "Style",
    type: "dropdown",
    html: function html() {
      var c = '<ul class="fr-dropdown-list">';
      var $current_image = this.cpImage.get();
      var options = this.opts.cpImage.imageStyles;

      if ($current_image.hasClass("cpSlideshowImages")) {
        options = this.opts.cpSlideshow.slideshowImageStyles;
      }

      for (var cls in options) {
        if (options.hasOwnProperty(cls)) {
          c += '<li><a class="fr-command" data-cmd="cpImageStyle" data-param1="' + cls + '">' + this.language.translate(options[cls]) + "</a></li>";
        }
      }

      c += "</ul>";
      return c;
    },
    callback: function callback(cmd, val) {
      this.cpImage.applyStyle(val);
    },
    refreshOnShow: function refreshOnShow($btn, $dropdown) {
      var $current_image = this.cpImage.get();

      if ($current_image) {
        $dropdown.find(".fr-command").each(function () {
          var cls = $(this).data("param1");
          $(this).toggleClass("fr-active", $current_image.hasClass(cls));
        });
      }
    }
  }); // Image alt.

  FE.DefineIcon("cpImageAlt", {
    NAME: "info",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageAlt", {
    undo: false,
    focus: false,
    title: "Alternate Text",
    callback: function callback() {
      this.cpImage.showAltPopup();
    }
  });
  FE.RegisterCommand("cpImageSetAlt", {
    undo: true,
    focus: false,
    title: "Update",
    refreshAfterCallback: false,
    callback: function callback() {
      if (window.isIE11()) {
        var altPopup = this.popups.get("cpImage.alt");
        var altTextValue = altPopup.find("input").val();
        $(".selectedFroalaImage").attr("alt", altTextValue);
      }

      this.cpImage.setAlt();
    }
  }); // Image size.

  FE.DefineIcon("cpImageSize", {
    NAME: "arrows-alt",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageSize", {
    undo: false,
    focus: false,
    title: "Change Size",
    callback: function callback() {
      this.cpImage.showSizePopup();
    }
  });
  FE.RegisterCommand("cpImageSetSize", {
    undo: true,
    focus: false,
    title: "Update",
    refreshAfterCallback: false,
    callback: function callback() {
      if (window.isIE11()) {
        var sizePopup = this.popups.get("cpImage.size");
        var widthTextValue = sizePopup.find('input[name="width"]').val();
        var heightTextValue = sizePopup.find('input[name="height"]').val();
        $(".selectedFroalaImage").css("width", widthTextValue);
        $(".selectedFroalaImage").css("height", heightTextValue);
      }

      this.cpImage.setSize();
    }
  }); //Custom Image link insert.

  FE.DefineIcon("cpImageLink", {
    NAME: "link",
    template: "font_awesome"
  });
  FE.DefineIcon("cpImageLinkOpen", {
    NAME: "external-link",
    template: "font_awesome"
  });
  FE.DefineIcon("cpImageLinkEdit", {
    NAME: "edit",
    template: "font_awesome"
  });
  FE.DefineIcon("cpImageLinkRemove", {
    NAME: "unlink",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpImageSetLink", {
    undo: true,
    focus: false,
    title: "Update",
    refreshAfterCallback: false,
    callback: function callback() {
      var linkPopup = this.popups.get("cpImage.link");
      var linkValue = linkPopup.find('input[name="href"]').val();
      var isHttp = /^http:.*/i.test(linkValue);
      var isHttps = /^https:.*/i.test(linkValue);
      var hasMailTo = /^mailto:.*/i.test(linkValue);
      var validEmail = emailValidate(linkValue);
      var relativeLink = linkValue.startsWith("/");

      if (!relativeLink) {
        if (!isHttp && !isHttps && !emailValidate(linkValue) && !hasMailTo) linkValue = "http://" + linkValue;else if (emailValidate(linkValue) && !hasMailTo) linkValue = "mailto:" + linkValue;
      }

      var newWindow = linkPopup.find('input[name="target"]').is(":checked");
      this.cpImage.setLink(linkValue, newWindow);
    }
  });
  FE.RegisterCommand("cpImageLink", {
    undo: false,
    focus: false,
    title: "Insert link",
    callback: function callback() {
      this.cpImage.showLinkPopup(false);
    }
  });
  FE.RegisterCommand("cpImageLinkEdit", {
    undo: false,
    focus: false,
    icon: "cpImageLinkEdit",
    title: "Edit link",
    callback: function callback() {
      this.cpImage.showLinkPopup(true);
    }
  });
  FE.RegisterCommand("cpImageLinkOpen", {
    undo: false,
    focus: false,
    icon: "cpImageLinkOpen",
    title: "Open link",
    callback: function callback() {
      this.cpImage.openLink();
    }
  });
  FE.RegisterCommand("cpImageLinkRemove", {
    undo: false,
    focus: false,
    icon: "cpImageLinkRemove",
    title: "Unlink",
    callback: function callback() {
      this.cpImage.removeLink();
    }
  }); //FE.DEFAULTS.toolbarButtons.push("cpImage");
  //imageLink method expects default image plugin.  Override with our custom plugin if default is not loaded.

  FE.COMMANDS.imageLink.callback = function () {
    var editor = this;
    if (editor.image == null) editor.image = editor.cpImage;
    editor.link.imageLink();
  };

  window.isIE11 = window.isIE11 || function () {
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var net = !!navigator.userAgent.match(/.NET4.0E/);
    return trident && net;
  };

  function emailValidate(emailAddress) {
    var emailAddressTrimmed = TrimString(emailAddress + "");

    if (emailAddressTrimmed != "") {
      if (checkSpecialScenarios(emailAddressTrimmed) == false) return false;
      if (emailAddressTrimmed.replace(/[^@]/g, "").length > 1) return false;
      var parts = emailAddressTrimmed.splitRemoveEmpties("@");
      if (emailAddressTrimmed.substr(emailAddressTrimmed.length - 1) == "@") return false;

      if (parts.length == 2) {
        for (var i = 0; i < parts.length; i++) {
          if ((!RegExValidate("^[A-Z0-9]$", parts[i].substr(0, 1), "i") || !RegExValidate("^[A-Z0-9]$", parts[i].substr(parts[i].length - 1), "i")) && i == 1 || !RegExValidate("^[A-Z0-9_%-\\.]+$", parts[i].substr(0, parts[i].length - 1), "i")) return false;
        }

        var lastDotPos = parts[1].lastIndexOf(".");
        if (lastDotPos < 0 || parts[1].substr(lastDotPos).length < 3 || !RegExValidate("^[A-Z]+$", parts[1].substr(lastDotPos + 1), "i")) return false;else return true;
      } else return false;
    } else return false;
  } // Used for validating emailaddress for special scenarios like continuous periods. - VB


  function checkSpecialScenarios(s) {
    var bugchars = "!#$^&*()|}{[]?><~%:;/,=`\"'";
    var i;
    var lchar = ""; // Search through string's characters one by one.
    // If character is not in bag.

    for (i = 0; i < s.length; i++) {
      // Check that current character isn't whitespace.
      var c = s.charAt(i);
      if (i > 0) lchar = s.charAt(i - 1);
      if (bugchars.indexOf(c) != -1 || lchar == "." && c == ".") return false;
    }

    return true;
  } // Removes leading and trailing white space from a string. Will blow up on NULLs.


  function TrimString(strInput) {
    return strInput.replace(/^\s+/g, "").replace(/\s+$/g, "");
  } // Form validation functions:


  function RegExValidate(expression, value, param) {
    var re = new RegExp(expression, param);

    if (value != "" && value != undefined) {
      if (value.match(re)) return true;else return false;
    } else return true;
  }

  String.prototype.splitRemoveEmpties = function (separator, howmany) {
    var splitArr;
    var returnArr = new Array();
    if (arguments.length == 2) splitArr = this.split(separator, howmany);else splitArr = this.split(separator);

    for (var i = 0; i < splitArr.length; i++) {
      if (splitArr[i] != "") returnArr.push(splitArr[i]);
    }

    return returnArr;
  };
});